import React, { Component } from 'react';
import { get, post } from 'axios';
import { inject, observer } from 'mobx-react';

@inject('userStore')
@observer
class BookingsPersonalServices extends Component {
    constructor(props){
        super(props);
        this.state = {
          serviceExpanded:false
        }
    }

    render() {
        const {service_list, artist_list, event} = this.props;
        var bus_user_id = 0;
        if (artist_list){
          let bus_user_list = artist_list.filter((artist) => artist.bus_user.user_id === this.props.userStore.id);
          if (bus_user_list.length > 0){
            bus_user_id = bus_user_list[0].bus_user.id;
          }
        }
        return (
          <div className={this.state.serviceExpanded ? "card card-outline-secondary" : "card card-outline-secondary card-slided-up"}>
              <header className="card-header">
                  <h4 className="card-title card-title-bold"><i className="fa fa-scissors"></i> Assigned Services & Artists</h4>
                  <ul className="card-controls">
                    <li><a onClick={(e)=>{e.preventDefault();this.setState({serviceExpanded:!this.state.serviceExpanded});}} className={this.state.serviceExpanded ? "card-btn-slide" : "card-btn-slide" } href="#"></a></li>
                  </ul>
              </header>
              <div className="card-content">
                  <ul className="nav nav-tabs nav-tabs-danger nav-justified" role="tablist">
                      <li className="nav-item">
                          <a className="nav-link active" data-toggle="tab" href={"#services_" + event.id} role="tab">Services</a>
                      </li>
                      <li className="nav-item">
                          <a className="nav-link" data-toggle="tab" href={"#participants_" + event.id} role="tab">Artists</a>
                      </li>
                  </ul>
                  <div className="card-body tab-content">
                      <div className="tab-pane fade active show" id={"services_" + event.id}>
                          <table className="table">
                              <tbody>
                              {service_list.length > 0 ?
                                service_list.map((service, index) => {
                                  if (service.bus_user_id && service.bus_user_id === bus_user_id) {
                                    return (
                                      <tr key={index}>
                                          <th scope="row">{service.name}</th>
                                      </tr>
                                    )
                                  }
                                })
                              :
                                <tr><td colSpan="4">No Services</td></tr>
                              }
                              </tbody>
                          </table>
                      </div>
                      <div className="tab-pane fade" id={"participants_" + event.id}>
                          <table className="table">
                              <tbody>
                              {artist_list.length > 0 ?
                                artist_list.map((artist, index) =>
                                <tr key={index}>
                                    <th scope="row">{artist.bus_user.full_name}</th>
                                    <td>{artist.is_trial_user ? <span className="badge badge-info">Lead Artist</span> : null}</td>
                                    <td>{artist.bus_user.email}</td>
                                    <td>{artist.bus_user.phone_primary}</td>
                                </tr>
                                )
                              :
                                <tr><td colSpan="2">No Artists</td></tr>
                              }
                              </tbody>
                          </table>
                      </div>
                  </div>
              </div>
          </div>
        );
    }
}

export default BookingsPersonalServices;



// WEBPACK FOOTER //
// ./src/components/business/BookingsPersonalServices.js